import { useMediaQuery as muiUseMediaQuery } from '@mui/material';

/**
 * MediaQuery를 사용하여 현재 화면과 비교 대상 너비를 비교합니다.
 *
 * @example
 * useMediaQuery(theme => theme.breakpoints.up('sm')); // 'sm' 사이즈 이상일 때 true (min-width: 800px)
 * useMediaQuery(theme => theme.breakpoints.down('md')); // 'md' 사이즈 미만일 때 true (max-width: 1279px)
 * useMediaQuery(theme => theme.breakpoints.between('sm', 'lg')); // 'sm' 이상, 'lg' 미만일 때 true (min-width: 800px, max-width: 1919px)
 */
export const useMediaQuery = muiUseMediaQuery;
